import { units } from '@ui/css';
import { combineTokens } from '@utils/css';

const tokens = combineTokens("--toggle-group", {
  selectedTabWidth: units.px(0),
  selectedTabOffsetLeft: units.px(0)
});
const initialRenderModifier = "dibi1twt79l";
const wrapper = "dibw13r0ukf";
const selectedTabHighlight = "dibs1gs6al4";
const tab = "dibt1fre4fn";

export { initialRenderModifier, selectedTabHighlight, tab, tokens, wrapper };
import "./toggle-group.style.linaria.module.css";
//# sourceMappingURL=toggle-group.style.js.map
